import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            KINOS CREATES TRANSFORMATIONAL ADVANTAGE FOR COMPLEX, DIVERSE FINANCIAL SERVICES ORGANIZATIONS
          </h2>
          <h3>HOW CAN WE HELP?</h3>
          <h5>New economic realities, continued regulatory pressure and the threat of disruption from technology are unrelenting forces driving changes in the financial services industry.
             These dynamics have compelled financial services firms to focus on controlling capital expense while balancing the need for top talent—profoundly impacting their market presence and real estate decisions.
            Kinos financial services  specialists partners work daily with global, regional and local banks, securities firms and insurance organizations to drive advantage and prepare for the future.
             Our work addresses critical challenges within portfolio optimization, space consolidation, cost containment, space management, hospitality services, merger integration,
              data management and risk management.
             Our expertise spans all dimensions of the built environment to reduce operating expenses and position real estate as a strategic business driver.
          </h5>
          <h5>
            Kinos's long-standing relationships, Torus Networks,  service and strategic capabilities, and pulse on the market enables a deep understanding of our client’s unique business needs.
            We are proud of our unmatched financial services practice and experience.
          </h5>

          <h5>Our Real Estate Finance practice is focused on the financing and refinancing of the sale, purchase and development of real estate assets of all types. We have a particularly strong track record advising on operating asset deals, including hotels, care homes, student accommodation, ground rent portfolios and the private rental sector.</h5>
          <h3>WHY CHOOSE OUR REAL ESTATE FINANCE  NETWORK SERVICES?</h3>
          <h5>The partners and collaborators for each operation are diverse. We are generating a circle of expert contacts in Real Estate Finance for each operation, with an excellent solidity of relationships with financial institutions and banks that have been correctly built over the years and with a culture of technical excellence, we managed to capture the necessary capital for the operations of Investments required.

</h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
